<template>
  <!-- 目录管理 -->
  <div class="page_padding">
    <div class="catalogPage page_content" v-if="authority">
      <!-- 顶部信息栏 -->
      <div class="top topAn">
        <div class="companyName">{{ companyName }}</div>
        <div class="fr" v-if="isAdmin">
          <el-button
            type="text"
            class="textBtn"
            size="small"
            @click="commonVisible = true"
            >配置通用站点</el-button
          >
          <!-- 选择公司 -->
          <el-select
            v-model="companyId"
            size="small"
            :disabled="!isAdmin"
            filterable
            placeholder="请选择"
          >
            <el-option
              v-for="item in companyList"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            >
            </el-option>
          </el-select>
        </div>
      </div>

      <!-- 站点列表 -->
      <div class="allSite" :loading="siteList_load">
        <el-tag
          :class="{ tag_active: index == site_index }"
          v-for="(item, index) in siteList"
          :key="index"
          :disable-transitions="false"
          @click="selectSite(index, item)"
        >
          <el-input
            class="input_tag"
            v-if="item.inputShow"
            v-model="item.siteName"
            ref="saveTagInput"
            size="small"
            @keyup.enter.native="editName(item, index)"
            @blur="editName(item, index)"
          >
          </el-input>
          <span>{{ item.siteName }}</span>
          <!-- 编辑按钮 -->
          <i
            class="el-icon-edit edit_icon"
            @click.stop="item.inputShow = true"
            v-if="item.companyid"
          ></i>
          <!-- 关闭按钮 -->
          <el-popconfirm
            title="确定删除该站点吗？"
            @confirm="onConfirmSite(item, index)"
            v-if="item.companyid"
          >
            <i slot="reference" class="el-icon-close del_icon"></i>
          </el-popconfirm>
        </el-tag>
        <!-- 新增输入框 -->
        <el-input
          class="input-new-tag"
          v-if="inputVisible"
          v-model="siteName"
          ref="saveTagInput"
          size="small"
          @keyup.enter.native="saveSite"
          @blur="saveSite"
        >
        </el-input>
        <!-- 新增按钮 -->
        <el-button v-else class="button-new-tag" size="small" @click="showInput"
          >+ 新增站点</el-button
        >
      </div>

      <!-- 站点详情  -->
      <div
        class="main"
        v-if="catalogueId && siteList.length != 0"
        v-load="detialLoading"
      >
        <div class="main_head">
          <p class="hint" v-if="is_common">
            此站点为通用站点，{{
              isAdmin
                ? "如要编辑站点内容请前往“配置通用站点”页面进行编辑"
                : "不可编辑"
            }}
          </p>
          <span v-else></span>
          <el-button
            type="text"
            class="textBtn"
            size="small"
            @click="editSiteDet"
            v-if="!is_common"
            >编辑</el-button
          >
        </div>

        <ul class="site_det">
          <!-- 信源 -->
          <li>
            <div class="det_title">信源:</div>
            <ul class="source_list">
              <li v-for="(item, index) in siteDte.sources" :key="index">
                {{ siteObj[item] }}
              </li>
            </ul>
          </li>
          <!-- 一级域名 -->
          <li>
            <div class="det_title">一级域名:</div>
            <div class="order_list domain">{{ siteDte.domain }}</div>
          </li>
          <!-- taskID -->
          <li>
            <div class="det_title">taskID:</div>
            <ul class="order_list">
              <li
                v-for="(taskId, taskIdIndex) in siteDte.taskId.split(',')"
                :key="taskIdIndex"
              >
                {{ taskIdObj[taskId] || taskId }}
              </li>
            </ul>
          </li>
          <!-- siteID -->
          <li>
            <div class="det_title">siteID:</div>
            <ul class="order_list">
              <li
                v-for="(siteId, siteIdIndex) in siteDte.siteId.split(',')"
                :key="siteIdIndex"
              >
                {{ siteIdObj[siteId] || siteId }}
              </li>
            </ul>
          </li>
        </ul>
      </div>

      <!-- 添加/编辑站点详情 -->
      <el-dialog
        :title="title + '站点详情'"
        custom-class="dialog_visible"
        :close-on-click-modal="false"
        :close-on-press-escape="false"
        :show-close="!isAddDet"
        :visible.sync="det_visible"
        top="5vh"
        width="1000px"
        @close="closeDetVisible"
      >
        <el-form :model="siteForm" :rules="rules" ref="siteForm">
          <!-- 信源 -->
          <el-form-item
            class="form_item checkbox_form"
            label="信源:"
            prop="siteTypes"
          >
            <div class="checkboxDom">
              <el-checkbox
                class="checkAll"
                :indeterminate="!checkAll"
                v-model="checkAll"
                @change="selectAll($event, 0)"
                >全选</el-checkbox
              >

              <el-checkbox-group
                v-model="siteForm.siteTypes"
                @change="selectSomeSource"
              >
                <el-checkbox
                  v-for="source in sourceList"
                  :label="source.id"
                  :key="source.id"
                  >{{ source.name }}</el-checkbox
                >
              </el-checkbox-group>
            </div>
          </el-form-item>
          <!-- 一级域名 -->
          <el-form-item class="form_item" label="一级域名:">
            <el-input
              type="textarea"
              :autosize="{ minRows: 4, maxRows: 8 }"
              placeholder="请输入一级域名（多个一级域名请用逗号隔开）"
              v-model="siteForm.domain"
            >
            </el-input>
          </el-form-item>

          <!-- taskID -->
          <el-form-item class="form_item checkbox_form" label="taskID:">
            <div class="checkboxDom">
              <el-cascader
                placeholder="请选择"
                :options="taskIdArr"
                :props="{ multiple: true }"
                :show-all-levels="false"
                v-model="taskIds"
              ></el-cascader>
            </div>
            <div class="null_data" v-if="Object.keys(taskIdObj).length == 0">
              没有可选的taskID
            </div>
          </el-form-item>
          <!-- siteID -->
          <el-form-item class="form_item checkbox_form" label="siteID:">
            <div class="checkboxDom">
              <el-cascader
                placeholder="请选择"
                :options="siteIdArr"
                :props="{ multiple: true }"
                :show-all-levels="false"
                v-model="siteIds"
              ></el-cascader>
            </div>
            <div class="null_data" v-if="Object.keys(siteIdObj).length == 0">
              没有可选的siteID
            </div>
          </el-form-item>
        </el-form>
        <div slot="footer" class="dialog_footer">
          <el-button size="small" @click="closeDetVisible" v-if="!isAddDet"
            >取 消</el-button
          >
          <el-button
            type="primary"
            size="small"
            :disabled="btn_loading"
            :loading="btn_loading"
            @click="submitForm"
            >确 定</el-button
          >
        </div>
      </el-dialog>

      <!-- 查看通用站点 -->
      <el-dialog
        title="通用站点"
        :top="dialog_top"
        width="70%"
        :visible.sync="commonVisible"
      >
        <!-- 站点列表 -->
        <div class="allSite" :loading="siteList_load">
          <el-tag
            :class="{ tag_active: index == commonSite_index }"
            v-for="(item, index) in siteList"
            :key="index"
            :disable-transitions="false"
            @click="selectSite(index, item)"
          >
            <el-input
              class="input_tag"
              v-if="item.inputShow"
              v-model="item.siteName"
              ref="saveTagInput"
              size="small"
              @keyup.enter.native="editName(item, index)"
              @blur="editName(item, index)"
            >
            </el-input>
            <span>{{ item.siteName }}</span>
            <!-- 编辑按钮 -->
            <i
              class="el-icon-edit edit_icon"
              @click.stop="item.inputShow = true"
            ></i>
            <!-- 关闭按钮 -->
            <el-popconfirm
              title="确定删除该站点吗？"
              @confirm="onConfirmSite(item, index)"
            >
              <i slot="reference" class="el-icon-close del_icon"></i>
            </el-popconfirm>
          </el-tag>
          <!-- 新增输入框 -->
          <el-input
            class="input-new-tag"
            v-if="inputVisible"
            v-model="siteName"
            ref="saveTagInput"
            size="small"
            @keyup.enter.native="saveSite"
            @blur="saveSite"
          >
          </el-input>
          <!-- 新增按钮 -->
          <el-button
            v-else
            class="button-new-tag"
            size="small"
            @click="showInput"
            >+ 新增通用站点</el-button
          >
        </div>

        <!-- 站点详情  -->
        <div
          class="main"
          v-if="catalogueId && siteList.length != 0"
          v-load="detialLoading"
        >
          <div class="main_head">
            <span></span>
            <el-button
              type="text"
              class="textBtn"
              size="small"
              @click="editSiteDet"
              >编辑</el-button
            >
          </div>

          <ul class="site_det">
            <!-- 信源 -->
            <li>
              <div class="det_title">信源:</div>
              <ul class="source_list">
                <li v-for="(item, index) in siteDte.sources" :key="index">
                  {{ siteObj[item] }}
                </li>
              </ul>
            </li>
            <!-- 一级域名 -->
            <li>
              <div class="det_title">一级域名:</div>
              <div class="order_list domain">{{ siteDte.domain }}</div>
            </li>
            <!-- taskID -->
            <li>
              <div class="det_title">taskID:</div>
              <ul class="order_list">
                <li
                  v-for="(taskId, taskIdIndex) in siteDte.taskId.split(',')"
                  :key="taskIdIndex"
                >
                  {{ taskIdObj[taskId] || taskId }}
                </li>
              </ul>
            </li>
            <!-- siteID -->
            <li>
              <div class="det_title">siteID:</div>
              <ul class="order_list">
                <li
                  v-for="(siteId, siteIdIndex) in siteDte.siteId.split(',')"
                  :key="siteIdIndex"
                >
                  {{ siteIdObj[siteId] || siteId }}
                </li>
              </ul>
            </li>
          </ul>
        </div>
      </el-dialog>
    </div>
    <div class="null_page" v-else>没有操作权限</div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      is_addName: true, // 是否新建、编辑站点名称
      siteIndex: null, // 记录编辑站点名称中的下标
      siteDte: { sources: [], taskId: "", siteId: "" }, // 站点详情
      isAddDet: true, // 是否新增、编辑详情
      siteList: [], // 站点列表
      sourceList: [], // 信源类型
      siteObj: {},
      detialLoading: false, // 加载站点详情
      loading: false,
      is_common: false, // 是否通用站点
      companyList: [],
      company_list: {},
      companyName: "", // 公司名称
      companyId: null, // 公司id
      inputVisible: false,
      siteName: "", // 新增站点名称
      siteList_load: false,
      site_index: 0, // 选中的站点index
      catalogueId: null, // 获取站点详情id
      checkAll: false, // 是否全选
      title: "新增",
      det_visible: false,
      btn_loading: false,
      siteForm: {
        // 站点新增、编辑详情数据
        catalogueId: "", // 表唯一id，修改时必传
        domain: "", // 一级域名
        siteId: "",
        taskId: "",
        siteDetailId: "", // 修改时必传
        siteTypes: [] // 信源
      },
      // 表单检验规则
      rules: {
        siteTypes: [
          { required: true, message: "请选择至少一个信源", trigger: "blur" }
        ]
      },
      is_input: [], // 记录是否至少输入了一个条件
      commonVisible: false, // 查看通用站点
      dialog_top: "15vh",
      commonSite_index: 0, // 记录通用站点下标

      siteIdArr: [],
      taskIdArr: [],
      siteIdObj: {},
      taskIdObj: {},
      taskIdAll: false,
      siteIdAll: false,
      taskIds: [],
      siteIds: []
    };
  },
  computed: {
    authority() {
      return this.$route.meta.authority;
    },
    isAdmin() {
      return this.$store.state.isAdmin;
    },
    company_id() {
      return this.$store.state.companyId;
    }
  },
  watch: {
    companyId(val) {
      this.companyName = this.company_list[val];
      this.catalogueId = null;
      this.companyId = val;
      this.site_index = 0;
      this.getSiteList();
    },
    commonVisible(val) {
      if (val) {
        this.commonSite_index = 0;
        this.siteDte = {
          sources: [],
          domain: "",
          siteId: "",
          taskId: ""
        };
        this.getCommonSiteList();
      } else {
        this.getSiteList();
      }
    },
    "siteForm.domain": {
      deep: true,
      handler(newV, oldV) {
        this.siteForm.domain = newV.replace("，", ",");
        this.saveInput("domain", newV);
      }
    },
    "siteForm.taskId": {
      deep: true,
      handler(newV, oldV) {
        this.siteForm.taskId = newV.replace("，", ",");
        this.saveInput("taskId", newV);
      }
    },
    "siteForm.siteId": {
      deep: true,
      handler(newV, oldV) {
        this.siteForm.siteId = newV.replace("，", ",");
        this.saveInput("siteId", newV);
      }
    },
    taskIds(val) {
      let arr = [];
      val.forEach(item => {
        arr.push(item[1]);
      });
      this.siteForm.taskId = arr.join(",");
      this.taskIdAll = val.length == Object.keys(this.taskIdObj).length;
    },
    siteIds(val) {
      let arr = [];
      val.forEach(item => {
        arr.push(item[1]);
      });
      this.siteForm.siteId = arr.join(",");
      this.siteIdAll = val.length == Object.keys(this.siteIdObj).length;
    }
  },
  created() {
    this.getCompanyList();
    this.getSiteTypes();
  },
  activated() {
    this.getAllId();
  },
  mounted() {
    this.$nextTick(() => {
      this.changeTableHeight();
    });

    window.onresize = () => {
      this.changeTableHeight();
    };
  },
  methods: {
    // 获取公司列表
    getCompanyList() {
      if (!this.authority) return;
      this.$http({
        url: this.$api.company_list
      }).then(res => {
        if (res.code == 0) {
          this.companyList = [];
          if (!res.data.length) {
            this.getSiteList();
            return;
          }
          res.data.forEach(el => {
            if (this.isAdmin) {
              this.companyList.push({
                value: el.companyid,
                label: el.companyname
              });
              this.company_list[el.companyid] = el.companyname;
            } else {
              if (el.companyid == this.company_id) {
                this.companyList.push({
                  value: el.companyid,
                  label: el.companyname
                });
                this.company_list[el.companyid] = el.companyname;
              }
            }
          });
          if (this.companyList.length > 0) {
            this.companyId = this.companyList[0].value;
            this.companyName = this.companyList[0].label;
          } else {
            this.companyId = null;
          }
        } else {
          this.getSiteList();
        }
      });
    },
    // 获取所有taskID、siteID
    getAllId() {
      this.$http({
        url: this.$api.id_list,
        data: {
          siteType: ""
        }
      }).then(res => {
        if (res.code == 0) {
          this.siteIdObj = {};
          this.taskIdObj = {};
          this.siteIdArr = [];
          this.taskIdArr = [];
          res.data.siteId.forEach(val => {
            let obj = {
              value: val.id,
              label: val.siteName,
              children: []
            };
            val.children.forEach(idItem => {
              this.siteIdObj[idItem.siteId] = idItem.siteName;
              obj.children.push({
                value: idItem.siteId,
                label: idItem.siteName
              });
            });
            this.siteIdArr.push(obj);
          });
          res.data.taskId.forEach(val => {
            let obj = {
              value: val.id,
              label: val.siteName,
              children: []
            };
            val.children.forEach(idItem => {
              this.taskIdObj[idItem.siteId] = idItem.siteName;
              obj.children.push({
                value: idItem.siteId,
                label: idItem.siteName
              });
            });
            this.taskIdArr.push(obj);
          });
        }
      });
    },
    // 获取站点列表
    getSiteList() {
      this.siteList_load = true;
      this.$http({
        url: this.$api.site_list,
        data: {
          companyid: this.companyId
        }
      })
        .then(res => {
          this.siteList_load = false;
          if (res.code == 0) {
            this.siteList = [];
            res.data.forEach((val, i) => {
              val.inputShow = false;
              val.companyid
                ? this.siteList.push(val)
                : this.siteList.unshift(val);
            });
            if (this.site_index > this.siteList.length - 1)
              this.site_index = this.siteList.length - 1;
            if (res.data.length != 0)
              this.selectSite(this.site_index, this.siteList[this.site_index]);
          }
        })
        .catch(err => {
          this.siteList_load = false;
        });
    },
    // 获取通用站点列表
    getCommonSiteList() {
      this.siteList_load = true;
      this.siteList = [];
      this.$http({
        url: this.$api.commonSite_list,
        data: {
          pageIndex: 1,
          pageSize: 100
        }
      })
        .then(res => {
          this.siteList_load = false;
          if (res.code == 0) {
            res.data.concent.forEach(val => {
              val.inputShow = false;
              this.siteList.unshift(val);
            });
            if (res.data.length != 0)
              this.selectSite(
                this.commonSite_index,
                this.siteList[this.commonSite_index]
              );
          }
        })
        .catch(err => {
          this.siteList_load = false;
        });
    },
    // 获取站点详情
    getSiteDet() {
      this.detialLoading = true;
      this.siteDte.sources = [];
      this.siteDte.domain = "";
      this.siteDte.siteId = "";
      this.siteDte.taskId = "";
      this.$http({
        url: this.$api.site_det,
        data: {
          catalogueId: this.catalogueId
        }
      })
        .then(res => {
          this.detialLoading = false;
          if (res.code == 0) {
            if (res.data) {
              this.siteDte = res.data;
              if (res.data.domain == null) this.siteDte.domain = "";
              if (res.data.siteId == null) this.siteDte.siteId = "";
              if (res.data.taskId == null) this.siteDte.taskId = "";
              this.siteDte.sources = res.data.siteTypes.split(",");
              console.log(this.siteDte);
            }
          } else {
            this.$hint(res.message, "err");
          }
        })
        .catch(err => {
          this.$hint(res.message, "err");
          this.detialLoading = false;
        });
    },
    // 获取所有信源
    getSiteTypes() {
      this.$http({
        url: this.$api.siteType,
        data: {}
      }).then(res => {
        if (res.code == 0) {
          this.siteObj = res.data || {};
          this.sourceList = [];
          Object.keys(res.data).forEach(key => {
            this.sourceList.push({
              id: key,
              name: res.data[key]
            });
          });
        }
      });
    },
    // 新增/编辑站点名称请求
    addSiteName(siteName) {
      let flag_index = 0;
      if (this.siteList.length != 0) {
        this.siteList.forEach(site => {
          if (site.siteName == siteName) {
            flag_index++;
          }
        });
      }
      if (flag_index >= 2) {
        this.$hint("站点名字重复,请重新命名", "err");
        return;
      }
      let data = {
        siteName, // 站点目录名称
        isEnable: 1 // 是否启用,1=是，0=否
      };
      if (!this.is_addName) data.catalogueId = this.catalogueId; // 表唯一id，修改时必传
      if (!this.commonVisible) data.companyid = this.companyId; // 公司id（通用不传
      this.$http({
        url: this.$api.add_siteName,
        data
      }).then(res => {
        if (res.code == 0) {
          if (this.is_addName) {
            res.data.inputShow = false;
            this.siteList.push(res.data);
            this.det_visible = true;
            this.isAddDet = true;
            this.checkAll = false;
            this.commonVisible
              ? (this.title = "新增通用")
              : (this.title = "新增");
            this.catalogueId = res.data.catalogueId;
            console.log(this.catalogueId);
          } else {
            this.siteList[this.siteIndex].inputShow = false;
          }
        } else {
          this.$hint(res.message, "err");
        }
      });
    },
    // 新增/编辑站点详情请求
    addSiteDet() {
      this.btn_loading = true;
      let data = JSON.parse(JSON.stringify(this.siteForm));
      data.catalogueId = this.catalogueId;
      data.siteTypes = data.siteTypes.join(",");
      this.$http({
        url: this.$api.edit_siteDet,
        data
      }).then(res => {
        this.btn_loading = false;
        if (res.code == 0) {
          this.closeDetVisible();
          // 新增站点
          if (this.isAddDet) {
            this.site_index = this.siteList.length - 1;
            this.$hint("创建成功", "success");
          } else {
            // 编辑站点
            this.$hint("保存成功", "success");
          }
          this.selectSite(this.site_index, this.siteList[this.site_index]);
        } else {
          this.$hint(res.message, "err");
        }
      });
    },
    // 选择站点
    selectSite(index, item) {
      if (item.inputShow) return;
      this.commonVisible
        ? (this.commonSite_index = index)
        : (this.site_index = index);
      this.catalogueId = item.catalogueId;
      if (!this.commonVisible) this.is_common = !Boolean(item.companyid);
      this.getSiteDet();
    },
    // 删除站点
    onConfirmSite(item, index) {
      this.$http({
        url: this.$api.del_site,
        data: {
          catalogueId: item.catalogueId
        }
      }).then(res => {
        if (res.code == 0) {
          this.siteList.splice(index, 1);
          if (this.site_index == index) {
            if (this.siteList.length > 0) {
              if (index >= 0 && index < this.siteList.length) {
                this.site_index = index;
              } else {
                if (index == 0) this.site_index = 0;
                if (index == this.siteList.length)
                  this.site_index = this.siteList.length - 1;
              }
              this.selectSite(this.site_index, this.siteList[this.site_index]);
            } else {
              this.siteDte = {
                sources: [],
                domain: "",
                siteId: "",
                taskId: ""
              };
            }
          }
        } else {
          this.$hint(res.message, "err");
        }
      });
    },
    // 显示新增站点输入框
    showInput() {
      this.is_addName = true;
      this.inputVisible = true;
      this.$nextTick(_ => {
        this.$refs.saveTagInput.$refs.input.focus();
      });
    },
    // 新增站点
    saveSite() {
      if (this.siteName) {
        this.addSiteName(this.siteName);
      }
      this.inputVisible = false;
      this.siteName = "";
      this.taskIds = [];
      this.siteIds = [];
    },
    // 编辑站点名称
    editName(item, index) {
      this.is_addName = false;
      this.siteIndex = index;
      if (item.siteName) {
        this.addSiteName(item.siteName);
      } else {
        this.$hint("请输入站点名称", "err");
      }
    },
    // 选择所有信源
    selectAll(val, type) {
      switch (type) {
        case 0:
          this.siteForm.siteTypes = [];
          if (val) {
            this.sourceList.forEach(el => {
              this.siteForm.siteTypes.push(el.id);
            });
          }
          this.checkAll = val;
          break;
        case 1:
          this.taskIds = [];
          if (val) {
            Object.keys(this.taskIdObj).forEach(key => {
              this.taskIds.push(key);
            });
          }
          break;
        case 2:
          this.siteIds = [];
          if (val) {
            Object.keys(this.siteIdObj).forEach(key => {
              this.siteIds.push(key);
            });
          }
          break;
      }
    },
    // 选择某个信源
    selectSomeSource(data) {
      let checkedCount = data.length;
      this.checkAll = checkedCount === this.sourceList.length;
    },
    // 记录输出框输入情况
    saveInput(tag, val) {
      let index = this.is_input.indexOf(tag);
      if (val == "") {
        if (index != -1) this.is_input.splice(index, 1);
      } else {
        if (index == -1) this.is_input.push(tag);
      }
    },
    // 提交详情内容
    submitForm() {
      this.$refs.siteForm.validate(valid => {
        if (valid) {
          if (this.is_input.length == 0) {
            this.$hint("一级域名、siteId、taskId至少输入其中一个", "err");
          } else {
            this.addSiteDet();
          }
        } else {
          return false;
        }
      });
    },
    // 关闭详情弹窗
    closeDetVisible() {
      this.siteForm = {
        catalogueId: "", // 表唯一id，修改时必传
        domain: "", // 一级域名
        siteId: "",
        taskId: "",
        siteDetailId: "", // 修改时必传
        siteTypes: [] // 信源
      };
      this.det_visible = false;
    },
    // 点击编辑站点详情
    editSiteDet() {
      this.commonVisible ? (this.title = "编辑通用") : (this.title = "编辑");
      this.det_visible = true;
      this.isAddDet = false;
      let item = this.siteDte;
      let siteTypes = item.sources;
      if (siteTypes.length == this.sourceList.length) this.checkAll = true;
      this.siteForm = {
        catalogueId: item.catalogueId, // 表唯一id，修改时必传
        domain: item.domain, // 一级域名
        siteId: item.siteId,
        taskId: item.taskId,
        siteDetailId: item.siteDetailId, // 修改时必传
        siteTypes // 信源
      };
      let taskArr = item.taskId.split(",");
      let siteArr = item.siteId.split(",");
      this.taskIds = [];
      this.siteIds = [];
      this.taskIdArr.forEach(val => {
        val.children.forEach(child => {
          taskArr.forEach(id => {
            if (child.value == id) this.taskIds.push([val.value, id]);
          });
        });
      });
      this.siteIdArr.forEach(val => {
        val.children.forEach(child => {
          siteArr.forEach(id => {
            if (child.value == id) this.siteIds.push([val.value, id]);
          });
        });
      });
    },
    // 计算表格高度
    changeTableHeight() {
      let window_height =
        document.documentElement.clientHeight || document.body.clientHeight;
      this.table_height = window_height - 230;
      if (this.table_height < 500) {
        this.dialog_top = "5vh";
      } else {
        this.dialog_top = "15vh";
      }
    }
  }
};
</script>

<style lang="less" scoped>
.catalogPage {
  color: #525f7f;
  .top {
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding-bottom: 8px;
    border-bottom: 1px solid #eef;
    .companyName {
      font-size: 16px;
      font-weight: bold;
    }
    .fr {
      display: flex;
      .textBtn {
        margin-right: 20px;
        color: #525f7f;
      }
    }
  }

  /* 站点 */
  .allSite {
    min-height: 50px;
    font-size: 14px;
    padding-top: 10px;
    display: flex;
    flex-wrap: wrap;
    .edit_icon {
      margin-left: 5px;
      cursor: pointer;
    }
    .del_icon {
      cursor: pointer;
    }
  }
  /* 主体  */
  .main {
    min-height: 0;
    flex: 1;
    display: flex;
    flex-direction: column;
    .main_head {
      display: flex;
      align-items: center;
      justify-content: space-between;
      margin-bottom: 10px;
      .hint {
        font-size: 12px;
        color: rgba(230, 162, 60, 0.9);
      }
    }

    .site_det {
      height: 0;
      flex: 1;
      overflow-y: scroll;
      > li {
        width: 100%;
        display: flex;
        font-size: 13px;
        margin-bottom: 10px;
        background: #f9f9f9;
        padding: 10px;
        border-radius: 5px;
        .det_title {
          width: 80px;
          color: #525f7f;
          font-weight: bold;
          white-space: nowrap;
        }
        .source_list {
          display: flex;
          > li {
            margin-right: 10px;
          }
        }
        .order_list {
          flex: 1;
          width: 0;
          word-wrap: break-word;
          word-break: normal;
          line-height: 20px;
          display: flex;
          flex-wrap: wrap;
          > li {
            margin-right: 15px;
            &:nth-last-child(1) {
              margin: 0;
            }
          }
        }
        .domain {
          display: block;
        }
      }
    }
  }
  .form_item {
    margin-bottom: 20px;
  }
  .checkbox_form {
    display: flex;
  }
  .checkboxDom {
    width: 900px;

    .el-cascader {
      width: 100%;
    }
    // /deep/ .el-checkbox-group {
    //   line-height: 30px;
    // }
    // /deep/ .el-checkbox {
    //   height: 20px;
    //   line-height: 20px;
    // }
  }
}

/deep/ .el-textarea__inner {
  font-size: 13px;
}
/deep/ .el-checkbox__label {
  font-size: 13px;
}
/deep/.checkbox_form {
  .el-form-item__label {
    white-space: nowrap;
  }
}
</style>

<style lang="less">
.dialog_visible {
  .el-dialog__header {
    padding: 20px 20px 0px;
  }
  .el-dialog__body {
    padding: 10px 20px;
  }
  .el-dialog__footer {
    padding: 0px 20px 10px;
  }
}
</style>

<style></style>



// WEBPACK FOOTER //
// src/pages/index/views/menuManage.vue